<template>
    <v-card-text class="subtitle-1 black--text">
        <v-row dense>
            <v-col cols="12" class="text-right">
                <v-btn outlined @click="downloadForm()">
                    <v-icon left small>fas fa-download</v-icon>
                    Download Form
                </v-btn>
            </v-col>
        </v-row>
        <div id="fullSubmission">
            <v-row>
                <v-col cols="12" class='text-left'>
                    <v-img contain height="150" width="150" src="@/assets/mount-logo-black.jpeg"></v-img>
                </v-col>
            </v-row>
            <v-row dense class="grey lighten-3">
                <v-col cols="12" md="6">Date/Time Submitted: <u>{{submission.dateTime}}</u></v-col>
                <v-col cols="12" md="6">Request Status: <u>{{submission.status}}</u></v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" md="6">Contact Name: <u>{{submission.name}}</u></v-col>
                <v-col cols="12" md="6">Contact Email: <u>{{submission.email}}</u></v-col>
                <v-col cols="12" md="6">Contact Phone: <u>{{submission.phone}}</u></v-col>
                <v-col cols="12" md="6">Request Type: <u>{{reqType[submission.type]}}</u></v-col>
            </v-row>
            <v-row dense class="grey lighten-3">
                <v-col cols="12" v-if="submission.type == 'external'">Group Name: <u>{{submission.groupName}}</u></v-col>
                <v-col cols="12" v-if="submission.type == 'external'">Group Address: <u>{{submission.groupAddress}}</u></v-col>
                <v-col cols="12" md="6">{{submission.type == 'overnight' ? 'Group Name' : 'Event Title'}}: <u>{{submission.title}}</u></v-col>
                <v-col cols="12" md="6">{{submission.type == 'overnight' ? 'Group Mailling Address' : 'Event Description'}}: <u>{{submission.description}}</u></v-col>
                <v-col cols="12" md="6">{{submission.type == 'overnight' ? 'Arrival Date' : 'Event Begin Date'}}: <u>{{submission.startDate}}</u></v-col>
                <v-col cols="12" md="6">{{submission.type == 'overnight' ? 'Departure Date' : 'Event End Date'}}: <u>{{submission.endDate}}</u></v-col>
                <v-col cols="12" md="6">Event Start Time: <u>{{submission.startTime}}</u></v-col>
                <v-col cols="12" md="6">Event End Time: <u>{{submission.endTime}}</u></v-col>
                <v-col cols="12" md="6">Set Up Time: <u>{{submission.setupTime}}</u></v-col>
                <v-col cols="12">
                    Event Goals/Objectives:
                    <br>
                    <u>{{submission.objectives}}</u>
                </v-col>
                <v-col cols="12" v-if="submission.extraInfo">
                    Other Pertinent Information: 
                    <br>
                    <u>{{submission.extraInfo}}</u>
                </v-col>
            </v-row>
            <v-row dense class="grey lighten-3" v-if="submission.type != 'overnight'">
                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                    Requested Resources:
                </v-col>
                <v-col cols="6" md="4" v-for="resource in submission.resources" :key="resource"><li>{{resourceName[resource]}}</li></v-col>
                <v-col cols="12" v-if="submission.resources.includes('classrooms')">
                    Requested Classrooms: <u>{{submission.classrooms}}</u>
                </v-col>
                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" v-if="submission.resources.includes('van')">
                    Approved Driver(s): <u>{{submission.driver}}</u>
                </v-col>
                <v-col cols="12" md="6">
                    Fee to Participants? <u>{{submission.charge}}</u>
                </v-col>
                <v-col cols="12" md="6" v-if="submission.costInfo">
                    Fee Information <u>{{submission.costInfo}}</u>
                </v-col>
                <v-col cols="12" md="6">
                    Serving Food/Drink? <u>{{submission.food}}</u>
                </v-col>
                <v-col cols="6" md=4>
                    Anticipated Number of Participants: <u>{{submission.expectedNum}}</u>
                </v-col>
            </v-row>
            <v-row dense v-if="submission.type == 'ministry-onSite' || submission.type == 'ministry-offSite'">
                <v-col cols="12" md="6">Target Audience: <u>{{submission.audience}}</u></v-col>
                <v-col cols="12" md="6">Responsible Ministry: <u>{{submission.ministry}}</u></v-col>
                <v-col cols="12" md="6">Responsible Set Up: <u>{{submission.setupPerson}}</u></v-col>
                <v-col cols="12" md="6">Responsible Tear Down: <u>{{submission.teardown}}</u></v-col>
                <v-col cols="12" md="6">Recurring Event? <u>{{submission.recurring}}</u></v-col>
                <v-col cols="12" md="6" v-if="submission.budgeted">Budgeted Event? <u>{{submission.budgeted}}</u></v-col>
                <v-col cols="12" md="6" v-if="submission.recurring == 'custom'">Event Frequency <u>{{submission.custom}}</u></v-col>
                <v-col cols="12">Requested Promotion:</v-col>
                <v-col cols="6" md="4" v-for="item in submission.promotion" :key="item"><li> {{promoType[item]}}</li></v-col>
                <v-col cols="12" md="6">
                    Requested areas of staff assistance:
                    <br>
                    <u>{{submission.staffAssistance}}</u>
                </v-col>
            </v-row>
            <!-- IF IT IS AN OVERNIGHT REQUEST, SHOW THESE ITEMS -->
            <v-row dense v-if="submission.type == 'overnight'">
                <v-col cols="12">
                    Expected Number of...
                </v-col>
                <v-col cols="12" md="6">Adult Males: <u>{{submission.overnight.males.adult}}</u></v-col>
                <v-col cols="12" md="6">Adult Females: <u>{{submission.overnight.females.adult}}</u></v-col>
                <v-col cols="12" md="6">Males 12-17: <u>{{submission.overnight.males.twelveToSeventeen}}</u></v-col>
                <v-col cols="12" md="6">Females 12-17: <u>{{submission.overnight.females.twelveToSeventeen}}</u></v-col>
                <v-col cols="12" md="6">Males 0-11: <u>{{submission.overnight.males.zeroToEleven}}</u></v-col>
                <v-col cols="12" md="6">Females 0-11: <u>{{submission.overnight.females.zeroToEleven}}</u></v-col>
                <v-col cols="12">Special Needs: <u>{{submission.overnight.specialNeeds}}</u></v-col>
                <v-col cols="12">Referred By: <u>{{submission.overnight.referallInfo}}</u></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row v-if="submission.reviews.length > 0" no-gutters>
                <v-col cols="12" class="title">
                    Submitted Reviews:
                </v-col>
                <v-col cols="12">
                    <v-card v-for="(item, i) in submission.reviews" :key="i" class="notetable" flat>
                        <v-row no-gutters>
                            <v-col cols="12">
                                Person submitting review: <u>{{item.name}}</u>
                            </v-col>
                            <v-col cols="12">
                                Approximate Attendance: <u>{{item.number}}</u>
                            </v-col>
                            <v-col cols="12">
                                More or less than expected: <u>{{item.numExpected}}</u>
                            </v-col>
                            <v-col cols="12">
                                What were some highlights from this event?
                                <v-text-field readonly v-model="item.highlights" outlined></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                What are some improvements for future iterations of this event?
                                <v-text-field readonly v-model="item.improvements" outlined></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                Describe how the objectives above were met or could better be met during future iterations of this event.
                                <v-text-field readonly v-model="item.objectives" outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <br>
        <v-divider></v-divider>
        <v-row no-gutters>
            <v-toolbar flat dense color='secondary' dark>Admin Notes:</v-toolbar>
            <v-col cols="12">
                <v-card flat>
                    <v-row no-gutters v-for="item in submission.commitMessages" :key="item.msg" class="notetable">
                        <v-col cols="12" md="4">{{item.author}}</v-col>
                        <v-col>{{item.msg}}</v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" class="text-center">
                <v-btn @click="$emit('edit')" outlined>
                    <v-icon left>fas fa-edit</v-icon>
                    Edit
                </v-btn>
            </v-col>
            <v-col cols="6" class="text-center">
                <v-btn @click="$emit('close')" outlined>
                    <v-icon left>fas fa-times</v-icon>
                    Close
                </v-btn>
            </v-col>
        </v-row>
    </v-card-text>
</template>
<script>
import html2pdf from 'html2pdf.js'
export default {
    props: {
        submissionInfo: Object
    },
    data(){
        return {
            promoType       : {
                bulletin            : "Bulletin",
                connectTable        : "Connection Center Table",
                email               : "Email Blast",
                paidAdvertising     : "Paid Advertising",
                printedMaterials    : "Printed Materials",
                screenGraphic       : "Screen Grahpic",
                stageAnnouncement   : "Stage Announcement",
                socialMedia         : "Social Media Posts",
                vidAnnouncement     : "Video Announcement",
                webApp              : "Web/Mount App Posts"
            },
            reqType         : {
                external            : "External Group Event Request",
                'ministry-onSite'   : "On-Campus Ministry Event",
                'ministry-offSite'  : "Off-Campus Ministry Event",
                overnight           : "Overnight Stay Request",
                personal            : "Personal"
            },
            resourceName    : {
                classrooms      : "Classrooms (see list)",
                conferenceRoom  : "Conference Room",
                connectionPoint : "Connection Point",
                lobby           : "Lobby",
                kitchen         : "Kitchen",
                van             : "Van",
                worshipCenter   : "Worship Center"
            },
            submission      : this.submissionInfo
        }
    },
    methods: {
        downloadForm(){
            let formData = document.getElementById('fullSubmission')
            let formatOptions = {
                margin:       .5,
                filename:     this.submissionInfo.title,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2 },
                jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' },
                pagebreak:    {mode: 'legacy'}
            }
            html2pdf().set(formatOptions).from(formData).save();
        }
    }
}
</script>

<style scoped>
.notetable:nth-child(odd){
  background: #CCC;
}
</style>